import React, { useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import Divider from '@mui/material/Divider';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';

import { LocalizationContext, SocketContext } from '../../../../../AppContext';
import Confirm from '../../../../../components/Confirm';
import Snackbar from '../../../../../components/Snackbar';
import localization from './ServicecategoriesPatch.local';

export default function ServicecategoriesPatch({
  servicecategories,
  onBack,
  onSetServicecategories,
}) {
  const local = localization[useContext(LocalizationContext)];
  const socket = useContext(SocketContext);
  const { servicecategoryid } = useParams();
  const [servicecategory, setServicecategory] = useState();
  const [name, setName] = useState('');
  const [typingTimeout, setTypingTimeout] = useState();
  const [alert, setAlert] = useState();
  const [openConfirm, setOpenConfirm] = useState();

  useEffect(() => {
    if (servicecategories && servicecategoryid) {
      const foundUser = servicecategories.find((item) => item.id === parseInt(servicecategoryid, 10));
      if (foundUser) {
        setServicecategory(foundUser);
      } else {
        onBack();
      }
    }
  }, [servicecategories, servicecategoryid]);

  useEffect(() => {
    if (servicecategory) {
      setName(servicecategory.name);
    }
  }, [servicecategory]);

  const acknowledgeChange = ({ error, payload }) => {
    setAlert(error || 200);
    if (!error) {
      onSetServicecategories(servicecategories ? servicecategories.map((item) => (item.id === payload.id ? payload : item)) : [payload]);
    }
  };

  const onChange = (field, value) => {
    const params = {
      id: servicecategories.id,
      field,
      value,
    };
    socket.emit('servicecategories.patch', params, acknowledgeChange);
  };

  const onTextChange = (setter, field, value) => {
    setter(value);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(setTimeout(() => onChange(field, value), 1000));
  };

  const acknowledgeDestroy = ({ error, payload }) => {
    if (error) {
      setAlert(error);
    } else {
      onSetServicecategories(servicecategories ? servicecategories.filter((item) => (item.id !== payload.id)) : []);
      onBack();
    }
  };

  const onDestroy = () => {
    const params = { id: servicecategory.id };
    socket.emit('servicecategories.destroy', params, acknowledgeDestroy);
  };

  return (
    <Paper sx={{ height: '100%', p: 5 }}>
      <Confirm
        title={local.destroyTitle}
        description={local.destroyDescription}
        agree={local.agree}
        disagree={local.disagree}
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onConfirm={onDestroy}
      />
      <Snackbar alert={alert} local={local.alerts} onClose={() => setAlert()} />
      <Typography variant="h4">{local.title}</Typography>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={5}>
            {local.firstname}
          </Grid>
          <Grid item xs={5}>
            <TextField
              fullWidth
              variant="outlined"
              color="secondary"
              margin="dense"
              label={local.name}
              value={name}
              onChange={(e) => onTextChange(setName, 'name', e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Stack spacing={1} sx={{ position: 'fixed', right: 30, bottom: 40 }}>
        { servicecategory && (
          <Fab
            variant="extended"
            color="primary"
            size="small"
            onClick={() => setOpenConfirm(true)}
            sx={{ justifyContent: 'flex-start' }}
          >
            <DeleteIcon sx={{ mr: 1 }} />
            <Typography>{local.destroy}</Typography>
          </Fab>
        )}
        <Fab
          variant="extended"
          color="secondary"
          size="small"
          onClick={onBack}
          sx={{ justifyContent: 'flex-start' }}
        >
          <CancelIcon sx={{ mr: 1 }} />
          <Typography>{local.back}</Typography>
        </Fab>
      </Stack>
    </Paper>
  );
}

ServicecategoriesPatch.propTypes = {
  servicecategories: PropTypes.arrayOf(PropTypes.shape({})),
  onBack: PropTypes.func.isRequired,
  onSetServicecategories: PropTypes.func.isRequired,
};

ServicecategoriesPatch.defaultProps = {
  servicecategories: undefined,
};
